var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ClientService from '../../api/ClientService';
import { Loading } from 'element-ui';
import Dialog from './Dialog.vue';
import _ from 'lodash';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.listData = [];
        _this.selectRows = [];
        _this.total = 0;
        _this.formData = {
            keyword: ''
        };
        return _this;
    }
    List.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 210;
        }, 300);
        this.service = ClientService.getInstance();
        this.getGroupList();
    };
    List.prototype.search = function () {
        this.getGroupList();
    };
    List.prototype.pageChange = function (pager) {
        this.getGroupList();
    };
    List.prototype.getGroupList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getGroups(Object.assign({}, { keyword: this.formData.keyword }, pager)).then(function (res) {
            _this.listData = res.data.data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    List.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    List.prototype.addGroup = function () {
        var _this = this;
        var instance = this.$dialog(Dialog, {}, {
            title: "添加分组",
            width: 500,
            height: 240
        }).instance;
        instance.$on("addGroup:ok", function () {
            window._czc.push(["_trackEvent", '客户分组列表', '添加客户组']);
            _this.getGroupList();
        });
    };
    List.prototype.editGroup = function (row) {
        var _this = this;
        var instance = this.$dialog(Dialog, {
            data: {
                group: row
            }
        }, {
            title: "编辑分组",
            width: 500,
            height: 240
        }).instance;
        instance.$on("editGroup:ok", function () {
            window._czc.push(["_trackEvent", '客户分组列表', '编辑客户组']);
            _this.getGroupList();
        });
    };
    List.prototype.deleteGroup = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error("请选择分组！");
            return;
        }
        this.$confirm('请确认是否删除该分组？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var ids = _.reduce(_this.selectRows, function (ori, newItem) {
                    return ori += ori ? (',' + newItem.group_id) : newItem.group_id;
                }, '');
                _this.service.delGroups({ id: ids }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success('删除成功！');
                        _this.getGroupList();
                    }
                    window._czc.push(["_trackEvent", '客户分组列表', '删除客户组']);
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function () {
        });
    };
    List = __decorate([
        Component
    ], List);
    return List;
}(Vue));
export default List;
